<kendo-stacklayout gap="30" orientation="horizontal" style="height:100%">
  <img #backgroundImage style="display:none" />
  @if(showLoginScreen){
    <div class="background">
      <div class="container">
        <kendo-card class="i-card">
          <div class="header">
            <img class="headerImg" src="../../../../assets/images/epclogo.png" />
            <h3 class="headerText">EPC Redeployment - Admin</h3>
          </div>
          <div class="card-body">
            @if(submitted && loginErrorMessage != undefined){
              <div>
                <span class="login-validation">{{loginErrorMessage}}</span>
              </div>
            }
            <div class="form-row">
              <div class="form-group col">
                <label>Please select an organization (you can change this at any time!):</label>
                <br />
                <br />
                <div class="organization-control">
                  <app-select-field [control]="organizationSelect"></app-select-field><!--formControlName="organization"-->
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <button kendoButton (click)="adminOrganization($event)" class="primary btnLogin">
              <span id="iconContainer" style="display:block;float:left"><fa-icon #icon [icon]="signIn"></fa-icon></span>
              &nbsp;&nbsp;
              Continue
            </button>
          </div>
        </kendo-card>
      </div>
    </div>
  }
</kendo-stacklayout>
